
import React from "react";
import FormField from "@/components/forms/FormField";
import FormTextArea from "@/components/forms/FormTextArea";
import CategorySelect from "@/components/forms/CategorySelect";

interface BusinessInfoSectionProps {
  name: string;
  description: string;
  address: string;
  city: string;
  county: string;
  postcode: string;
  what3words: string;
  region: string;
  category: string;
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleCategoryChange: (value: string) => void;
  formErrors: Record<string, string>;
}

const BusinessInfoSection: React.FC<BusinessInfoSectionProps> = ({
  name,
  description,
  address,
  city,
  county,
  postcode,
  what3words,
  region,
  category,
  handleChange,
  handleCategoryChange,
  formErrors,
}) => {
  return (
    <>
      <FormField
        id="name"
        label="Business Name"
        required
        value={name}
        onChange={handleChange}
        error={formErrors.name}
      />

      <FormTextArea
        id="description"
        label="Description"
        required
        value={description}
        onChange={handleChange}
        error={formErrors.description}
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FormField
          id="address"
          label="Address"
          value={address}
          onChange={handleChange}
          error={formErrors.address}
          placeholder="Optional street address"
        />

        <FormField
          id="city"
          label="City/Town"
          required
          value={city}
          onChange={handleChange}
          error={formErrors.city}
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FormField
          id="county"
          label="County/Region"
          value={county}
          onChange={handleChange}
          error={formErrors.county}
          placeholder="e.g. Greater Manchester, London (can be same as city)"
        />

        <FormField
          id="region"
          label="Region"
          value={region}
          onChange={handleChange}
          error={formErrors.region}
          placeholder="e.g. North West, South East"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FormField
          id="postcode"
          label="Postcode"
          value={postcode}
          onChange={handleChange}
          error={formErrors.postcode}
          placeholder="Optional postcode"
        />

        <FormField
          id="what3words"
          label="What3Words"
          value={what3words}
          onChange={handleChange}
          error={formErrors.what3words}
          placeholder="Optional what3words address"
        />
      </div>

      <CategorySelect
        value={category}
        onChange={handleCategoryChange}
        error={formErrors.category}
        required
      />
    </>
  );
};

export default BusinessInfoSection;
